import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, EventoAccreditamentoSummary } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-accredito-backoffice',
  templateUrl: './modifica-accredito-backoffice.component.html',
  styleUrl: './modifica-accredito-backoffice.component.css',
})
export class ModificaAccreditoBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute) {}

  evento?: Evento;
  summary?: EventoAccreditamentoSummary;
  loading: boolean = false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loading = true;
      const id = params['id'];
      this.apiService.getEvento(id).subscribe({
        next: (data) => this.evento = data,
        error: () => this.router.navigate(['/backoffice/area-compagnie']),
        complete: () => {
          this.apiService.getEventoAccreditamentoSummary(id).subscribe({
            next: (s) => this.summary = s,
            error: () => this.summary = undefined,
            complete: () => this.loading = false
          });
        }
      })
    })
  }

  statusLabel(level: string): string {
    switch (level) {
      case 'ok': return 'ok';
      case 'wait': return 'in attesa';
      case 'warn': return 'attenzione';
      case 'crit': return 'bloccante';
      case 'na': return 'n/a';
      default: return level;
    }
  }
}
